import { render, staticRenderFns } from "./CommonProductTypeSelect.vue?vue&type=template&id=83819a70&lang=pug&"
import script from "./CommonProductTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./CommonProductTypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CommonProductTypeSelect.vue?vue&type=style&index=0&id=83819a70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports